import size from '@/assets/theme/size';
import { Theme } from '@emotion/react';

const {
	mobile,
	tablet,
	desktopXs,
	desktopSm,
	laptop,
	desktopLg,
	desktopMl,
	desktopXl,
} = size;

const media: Theme['media'] = {
	mobile: `@media (min-width: ${mobile}px)`,
	tablet: `@media (min-width: ${tablet}px)`,
	desktop: {
		xs: `@media (min-width: ${desktopXs}px)`,
		sm: `@media (min-width: ${desktopSm}px)`,
		laptop: `@media (min-width: ${laptop}px)`,
		lg: `@media (min-width: ${desktopLg}px)`,
		ml: `@media (min-width: ${desktopMl}px)`,
		xl: `@media (min-width: ${desktopXl}px)`,
	},
};

export default media;
